/////////////////////////////////////////////////V5CommentStart
// 2023-01-08 - cloned and stripped dataview
// 2023-01-15 - Dirty version - two towers moved to singleblog post
// 2023-01-28 - cleaner research not flattened out , still blogview.inventory in the wayincluded
// 2023-03-04 - big tidy up
// 2023-03-06 - removed all the inventory stuff
/////////////////////////////////////////////////V5CommentEnd import React from 'react'
import React from 'react'
//import ReactDOM from 'react-dom'
import {
  Grid,
  Row,
  Col,
  Pagination,
  Pager,
  Button,
  Panel,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import queryString from 'query-string'

import './BlogView.css'
import SingleBlogPost from './SingleBlogPost'
 
//---------------------------------------
//
//---------------------------------------
class BlogViewer extends React.Component {
  constructor(props) {
    console.log(`CFD_FUNC_BlogView_constructorBlogViewer:`)
    super(props)
    this.state = {
//      items: null,
 //     itemCount: null,
      error: null,
    }
  }
  // i dont think it ever gets props

  componentWillReceiveProps(props) {
    console.log(`CFD_FUNC_BlogView_componentWillReceiveProps0********************************:`)
    if (this.props.location !== props.location) 
    {
      console.log(`CFD_FUNC_BlogView_componentWillReceiveProps1: is TRUE`)
      console.log(        `CFD_FUNC_BlogView_componentWillReceiveProps1a: ` + this.props.location      )
      console.log(        `CFD_FUNC_BlogView_componentWillReceiveProps1b: ` + props.location      )

      this.reload = true
    } else {
      console.log(`CFD_FUNC_BlogView_componentWillReceiveProps1: is FALSE`)
      console.log(`CFD_FUNC_BlogView_componentWillReceiveProps2a: ` + this.props.location )
    }
  }

  componentDidUpdate() {
    console.log(`CFD_FUNC_BlogView_componentDidupdateBlogViewer:`)
    if (this.reload) 
    {
      console.log(`CFD_FUNC_BlogView_componentDidupdateBlogViewerRunning relaod:`)

      this.loader()
      this.reload = false
    }
  }

  componentDidMount() {
    console.log(`CFD_FUNC_BlogView_componentDidmountBlogViewer:`)
    this.loader()
  }

  //DDSUNDAY - this loader isnt necessary
    
  loader = () => {
    const that = this
    const { load, ...props } = this.props
    console.log(`CFD_FUNC_BlogView_FUCK YOUR LOADER`)
 
  }
 

  //---------------------------------------
  // originally this was calling a blogviewwithcontrols after cloning dataview. not needed, i hope
  // script tags also pulled closer to the actual objects rather than here
  //---------------------------------------
  render() {
    // Show spinner while loading
    let mytesturl = this.props.location.pathname
    console.log(`CFD_FUNC_BlogView_renderBlogViewer stinkycheese***********************-` + mytesturl + '-' + this.props.location.pathname);
    console.log(`CFD_FUNC_BlogView_renderBlogViewer Beaverface ***********************-` + !this.reload );

    // this GRID was critical 
    
      return this.state.error || ( !this.reload) ? (
      <Grid >
      <div>  
          <Col className="blogGridRow" >
            <SingleBlogPost zipCode={this.props.zipCode}   redirURL={mytesturl} />
          </Col>
      </div>
      </Grid >
    ) : (
      <Col className="blogGridRow" >
        <div style={{ minHeight: `${window.innerHeight}px` }}>      <FontAwesome className="fa-spin fa-3x fa-fw" name="cog" /></div>
      </Col>
    )
  }
 
} // end class BlogViewer

const BlogView = {}
export default BlogView

//---------------------------------------
//Not sure this needed. it is definitely called. 
//---------------------------------------
BlogView.Asshole = class extends React.Component {
  render() {
    //DDFIX, this needs setitem adjustments
    console.log(`CFD_FUNC_BlogView_Asshole render 1` +  this.props.location.pathname)
    if (this.props.app.redirect) return null
    let search = queryString.parse(this.props.location.search)
    const { did } = this.props.match.params
    console.log( `CFD_FUNC_BlogView_Asshole render 2:` + this.props.app.state.myBasicParams.sort    )
    console.log(      `CFD_FUNC_BlogView_Asshole render 3:` +        this.props.location.search   )

    var tempstate = JSON.parse(localStorage.getItem('state'))
    console.log(      `CFD_FUNC_BlogView_Asshole render 4:` +        tempstate    )
    //    tempstate.myBasicParams.ipp = search.ipp
    // DDSUNDAY1  - marker for things i touched to get rid of inventory
    // DDSunday. to i need this load at all?
    const props = { ...this.props,  search, did}
    console.log(`CFD_FUNC_BlogView_Asshole 4:` + props)
    return <BlogViewer type="aaainventory" list {...props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/BlogView/BlogView.js